import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Services.css';
import saglikImage from '../assets/saglik.avif';
import isyeriImage from '../assets/isyeri.avif';
import konutImage from '../assets/konut.avif';
import trafikImage from '../assets/trafik.avif';

const Services = () => {
  const [expandedService, setExpandedService] = useState(null);
  const location = useLocation();

  const services = [
    {
      id: 'saglik',
      icon: '🏥',
      title: 'Sağlık Sigortası',
      shortDescription: 'Sağlığınız her zaman güvende.',
      detailedDescription: 'Sağlık sigortası, beklenmedik hastalıklar ve tedavi masraflarına karşı sizi güvence altına alır. Anlaşmalı hastanelerde kaliteli sağlık hizmetlerinden faydalanabilir, muayene, tahlil, ameliyat ve tedavi giderlerinizi bütçenizi zorlamadan karşılayabilirsiniz. Kendiniz ve sevdikleriniz için huzurlu bir gelecek sağlamak artık çok daha kolay.',
      image: saglikImage
    },
    {
      id: 'isyeri',
      icon: '🏢',
      title: 'İşyeri Sigortası',
      shortDescription: 'İşiniz bizimle güvende.',
      detailedDescription: 'İşyeri sigortası; yangın, hırsızlık, su baskını, doğal afetler ve beklenmedik risklere karşı iş yerinizi koruma altına alır. Demirbaşlarınız, makineleriniz ve stoklarınız güvence altındayken siz sadece işinize odaklanabilirsiniz. İş sürekliliğinizi korumak için en doğru çözümleri sunuyoruz.',
      image: isyeriImage
    },
    {
      id: 'konut',
      icon: '🏠',
      title: 'Konut Sigortası',
      shortDescription: 'Eviniz için tam koruma.',
      detailedDescription: 'Konut sigortası, evinizi ve eşyalarınızı yangın, deprem, hırsızlık, su baskını gibi risklere karşı güvence altına alır. Beklenmedik durumlarda maddi kayıp yaşamadan hayatınıza devam edebilmeniz için yanınızdayız. Eviniz sizin için ne kadar değerliyse, bizim için de o kadar değerli.',
      image: konutImage
    },
    {
      id: 'trafik',
      icon: '🚗',
      title: 'Trafik Sigortası',
      shortDescription: 'Yolda içiniz rahat olsun.',
      detailedDescription: 'Zorunlu trafik sigortası, kazalarda karşı tarafa verilebilecek maddi ve bedeni zararları teminat altına alır. Yasal zorunluluk olmasının yanı sıra sizi ve bütçenizi güvence altına alır. En uygun fiyatlarla, hızlı ve kolay çözümler sunuyoruz.',
      image: trafikImage
    },
    {
      id: 'sorumluluk',
      icon: '⚖️',
      title: 'Sorumluluk Sigortası',
      shortDescription: 'Risklere karşı güçlü koruma.',
      detailedDescription: 'Sorumluluk sigortası, üçüncü şahıslara karşı doğabilecek maddi ve manevi zararları güvence altına alır. İş hayatınızda ya da günlük yaşamda oluşabilecek riskleri düşünmenize gerek kalmadan, güvenle yolunuza devam etmenizi sağlar.',
      image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 'seyahat',
      icon: '✈️',
      title: 'Seyahat-Sağlık Sigortası',
      shortDescription: 'Seyahatinizde güvende olun.',
      detailedDescription: 'Seyahat sağlık sigortası, yurt içi ve yurt dışı seyahatlerinizde karşılaşabileceğiniz sağlık sorunlarına karşı sizi güvence altına alır. Acil tedavi, hastane masrafları ve beklenmedik durumlarda destek sunar. Tatilinizi huzurla yaşamanız için her zaman yanınızdayız.',
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ];

  // URL parametresine göre otomatik açılma
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const serviceParam = params.get('service');
    if (serviceParam) {
      setExpandedService(serviceParam);
      // Otomatik scroll
      setTimeout(() => {
        const element = document.getElementById(`service-${serviceParam}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  const toggleService = (serviceId) => {
    setExpandedService(expandedService === serviceId ? null : serviceId);
  };

  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1>Hizmetlerimiz</h1>
          <p>İhtiyacınıza uygun sigorta çözümlerini keşfedin</p>
        </div>
      </div>

      <div className="services-list">
        <div className="container">
          <div className="services-accordion">
            {services.map((service) => (
              <div
                key={service.id}
                id={`service-${service.id}`}
                className={`service-accordion-item ${expandedService === service.id ? 'expanded' : ''}`}
              >
                <div
                  className="service-card-accordion"
                  onClick={() => toggleService(service.id)}
                >
                  <div className="service-card-header">
                    <div className="service-icon" style={{ backgroundImage: `url(${service.image})` }}></div>
                    <div className="service-card-info">
                      <h3>{service.icon} {service.title}</h3>
                      <p>{service.shortDescription}</p>
                    </div>
                    <div className="service-toggle-icon">
                      {expandedService === service.id ? '▼' : '▶'}
                    </div>
                  </div>
                </div>

                <div className={`service-detail ${expandedService === service.id ? 'open' : ''}`}>
                  <div className="service-detail-content">
                    <h4>Detaylı Açıklama</h4>
                    <p>{service.detailedDescription}</p>
                    <a href="/iletisim" className="btn-service-contact">
                      Teklif Al →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;

